export default {
  fullWidth: {
    width: '100%',
    height: '100%',
    zIndex: 10001,
    position: 'fixed',
    top: '25%',
    left: '50%',
  },
}
